<template>
  <div v-if='showing' class='lottery-animation_wrapper'>
    <div class='lottery-animation_container'>
      <div class='lottery-animation_header'>
        <img :src="require('@/assets/modal/lottery_close.png')" alt="" class='close' @click="close_page">
        <img :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['drawLotteryImg']['drawLotteryTitle'][0]}`" alt="" class='title'>
      </div>
      <div class='lottery-animation_content' :class='[changeClass ? "small-box" : ""]' @click="chooseReward">
        <div class='lottery' v-for="(item,index) in list" :key="index" :class='className'>
          <img :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${item}`" alt="">
        </div>
        <img class='big-box' :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['drawLotteryImg']['lotteryBigBox'][0]}`" alt="">
      </div>
      <div v-if='isClick' class='tip'>{{count}}s后将自动为您选择</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'
export default {
  name: 'LotteryAnimation',
  data () {
    return {
      showing: false,
      baseUrl,
      timer: null, // setTimeout定时器
      timerSecond: null, // setTimeout定时器 底部文字使用
      timerThird: null, // 最终小盒子的定时器
      interval: null, // setInterval定时器
      list: [],
      count: 5,
      isClick: false,
      changeClass: false // 改变从奖品到箱子的宽高类名
    }
  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath']),
    className () {
      let num = {
        '7': 'length-7',
        '8': 'length-8'
      }
      return num[this.list.length]
    }
  },
  watch: {
    isClick: {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          if (this.count <= 0) {
            this.count = 5
            clearInterval(this.interval)
            return
          }
          if (!this.showing) return
          this.interval = setInterval(() => {
            this.count--
          }, 1000)
        }
      }
    },
    count: {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          if (newVal <= 0) {
            this.close_page()
            clearInterval(this.interval)
          }
        }
      }
    }
  },
  methods: {
    // 选择奖品
    chooseReward () {
      if (!this.isClick) return
      this.close_page()
    },
    show () {
      this.showing = true
      this.list = this.h5ConfigDetails[0]['drawLotteryImg']['lotteryImg']
      this.timer = setTimeout(() => {
        this.list = new Array(this.list.length).fill(this.h5ConfigDetails[0]['drawLotteryImg']['lotteryCardBack'][0])
      }, 2000)
      this.timerThird = setTimeout(() => {
        this.changeClass = true
      }, 2700)
      this.timerSecond = setTimeout(() => {
        this.isClick = true
      }, 2900)
    },
    close_page () {
      this.$emit('showLottery')
      this.isChangePic = false
      clearTimeout(this.timer)
      clearTimeout(this.timerSecond)
      clearTimeout(this.timerThird)
      clearInterval(this.interval)
      this.count = 5
      this.isClick = false
      this.showing = false
      this.changeClass = false
    }
  },
  beforeDestroy () {
    this.timer = null
    this.interval = null
  }
}
</script>

<style scoped lang="less">
  .lottery-animation{
    &_wrapper{
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0,0,0,0.65);
      z-index: 1001;
    }
    &_container{
      width: 33.2rem;
      height: 49.4rem;
      & .tip {
        color: #FFFFFF;
        text-align: center;
        font-size: 1.1rem;
        font-family: PingFangSC-Regular, PingFang SC
      }
    }
    &_header{
      position: relative;
      width: 100%;
      height: 7.9rem;
      & .close{
        width: 1.8rem;
        height: 1.8rem;
        position: absolute;
        left:0;
        top: 0;
      }
      & .title{
        width: 100%;
        height: 100%;
      }
    }
    &_content{
      width: 100%;
      height: 41.4rem;
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      & > .lottery{
        width: 9.4rem;
        height: 12.2rem;
        margin-bottom: 1.4rem;
        transform: scale(1);
        opacity: 1;
        transition: all;
        & > img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      & .big-box{
        position: absolute;
        top: 0;
        right:0;
        bottom:0;
        left: 0;
        margin: auto;
        width: 22.9rem;
        height: 22.9rem;
        transform: scale(0);
        transition: all;
        animation: showBigBox 1.6s 1s linear forwards;
        z-index: 1;
      }
    }
  }
  .lottery-animation_content .lottery:nth-child(1){
    animation: transofrm_pos1 2.6s 0.3s linear;
  }
  .lottery-animation_content .lottery:nth-child(2){
    animation: transofrm_pos2 2.4s 0.3s linear ;
  }
  .lottery-animation_content .lottery:nth-child(3){
    animation: transofrm_pos3 2.4s 0.4s linear ;
  }
  .lottery-animation_content .lottery:nth-child(4){
    animation: transofrm_pos4 2.6s 0.3s linear ;
  }
  .lottery-animation_content .lottery:nth-child(5){
    animation: transofrm_pos5 2.4s 0.3s linear ;
  }
  .lottery-animation_content .lottery:nth-child(6){
    animation: transofrm_pos6 2.6s 0.3s linear ;
  }
  .lottery-animation_content .lottery:nth-child(7){
    animation: transofrm_pos7 2.4s 0.4s linear ;
  }
  .lottery-animation_content .lottery:nth-child(8){
    animation: transofrm_pos8 2.4s 0.3s linear ;
  }
  .lottery-animation_content .lottery:nth-child(9){
    animation: transofrm_pos9 2.4s 0.4s linear ;
  }
  /*奖品长度为7时*/
    .lottery-animation_content .lottery.length-7:nth-child(7){
    animation: transofrm_pos7length_7 2.4s 0.4s linear ;
  }
  /**奖品长度为8时 */
  .lottery-animation_content .lottery.length-8:nth-child(7){
    animation: transofrm_pos7length_8 2.4s 0.4s linear ;
  }
  .lottery-animation_content .lottery.length-8:nth-child(8){
    animation: transofrm_pos8length_8 2.4s 0.3s linear ;
  }
  .lottery-animation_content.small-box{
    height: 32.6rem;
    margin-top: 1.83rem;
    & .lottery{
      width: 9.6rem;
      height: 9.6rem;
      margin-bottom: 0.6rem;
    }
  }
  @keyframes transofrm_pos1 {
    13%{
      transform: scale(0.8);
    }
    26%{
      transform: scale(1);
    }
    39%{
      transform: scale(0.8);
    }
    52%{
      transform: scale(1);
      opacity: 1;
    }
    60%{
      transform: translate(100%,-10%);
      opacity: 0.6;
    }
    80%{
      transform: translate(100%,100%);
      opacity: 0;
    }
    100%{
      opacity: 0;
    }
  }
  @keyframes transofrm_pos2 {
    13%{
      transform: scale(0.8);
    }
    26%{
      transform: scale(1);
    }
    39%{
      transform: scale(0.8);
    }
    52%{
      transform: scale(1);
      opacity: 1;
    }
    65%{
      transform: translate(0,75%);
      opacity: 0.6;
    }
    80%{
      transform: translate(0,100%);
      opacity: 0;
    }
    100%{
      opacity: 0;
    }
  }
  @keyframes transofrm_pos3 {
    13%{
      transform: scale(0.8);
    }
    26%{
      transform: scale(1);
    }
    39%{
      transform: scale(0.8);
    }
    52%{
      transform: scale(1);
      opacity: 1;
    }
    61%{
      transform: translate(-100%,-10%);
      opacity: 0.6;
    }
    75%{
      transform: translate(-100%,100%);
      opacity: 0;
    }
    100%{
      opacity: 0;
    }
  }
  @keyframes transofrm_pos4 {
    15%{
      transform: scale(0.8);
    }
    30%{
      transform: scale(1);
    }
    45%{
      transform: scale(0.8);
    }
    60%{
      transform: scale(1);
      opacity: 1;
    }
    61%{
      transform: translate(50%,0);
      opacity: 0.6;
    }
    75%{
      transform: translate(100%,0);
      opacity: 0;
    }
    100%{
      opacity: 0;
    }
  }
  @keyframes transofrm_pos5 {
    13%{
      transform: scale(0.8);
    }
    26%{
      transform: scale(1);
    }
    39%{
      transform: scale(0.8);
    }
    52%{
      transform: scale(1);
      opacity: 1;
    }
    69%{
      transform: translate(0,0);
      opacity: 0.6;
    }
    100%{
      opacity: 0;
    }
  }
  @keyframes transofrm_pos6 {
    15%{
      transform: scale(0.8);
    }
    30%{
      transform: scale(1);
    }
    45%{
      transform: scale(0.8);
    }
    60%{
      transform: scale(1);
      opacity: 1.6;
    }
    61%{
      transform: translate(-50%,0);
      opacity: 0.6;
    }
    75%{
      transform: translate(-100%,0);
      opacity: 0;
    }
    100%{
      opacity: 0;
    }
  }
  @keyframes transofrm_pos7 {
    15%{
      transform: scale(0.8);
    }
    30%{
      transform: scale(1);
    }
    45%{
      transform: scale(0.8);
    }
    60%{
      transform: scale(1);
      opacity: 1;
    }
    61%{
      transform: translate(50%,-50%);
      opacity: 0.6;
    }
    75%{
      transform: translate(100%,-100%);
      opacity: 0;
    }
    100%{
      opacity: 0;
    }
  }
  @keyframes transofrm_pos8 {
    13%{
      transform: scale(0.8);
    }
    26%{
      transform: scale(1);
    }
    39%{
      transform: scale(0.8);
    }
    52%{
      transform: scale(1);
      opacity: 1;
    }
    60%{
      transform: translate(50,-50%);
      opacity: 0.6;
    }
    80%{
      transform: translate(100,-100%);
      opacity: 0;
    }
    100%{
      opacity: 0;
    }
  }
  @keyframes transofrm_pos9 {
    15%{
      transform: scale(0.8);
    }
    30%{
      transform: scale(1);
    }
    45%{
      transform: scale(0.8);
    }
    60%{
      transform: scale(1);
      opacity: 1;
    }
    61%{
      transform: translate(-30%,-30%);
      opacity: 0.6;
    }
    75%{
      transform: translate(-50%,-50%);
      opacity: 0;
    }
    100%{
      opacity: 0;
    }
  }
  @keyframes transofrm_pos7length_7{
    15%{
      transform: scale(0.8);
    }
    30%{
      transform: scale(1);
    }
    45%{
      transform: scale(0.8);
    }
    60%{
      transform: scale(1);
      opacity: 1;
    }
    61%{
      transform: translate(0%,-50%);
      opacity: 0.6;
    }
    75%{
      transform: translate(0,-100%);
      opacity: 0;
    }
    100%{
      opacity: 0;
    }
  }
  @keyframes transofrm_pos7length_8{
    15%{
      transform: scale(0.8);
    }
    30%{
      transform: scale(1);
    }
    45%{
      transform: scale(0.8);
    }
    60%{
      transform: scale(1);
      opacity: 1;
    }
    61%{
      transform: translate(30%,-30%);
      opacity: 0.6;
    }
    75%{
      transform: translate(50%,-50%);
      opacity: 0;
    }
    100%{
      opacity: 0;
    }
  }
  @keyframes transofrm_pos8length_8{
    15%{
      transform: scale(0.8);
    }
    30%{
      transform: scale(1);
    }
    45%{
      transform: scale(0.8);
    }
    60%{
      transform: scale(1);
      opacity: 1;
    }
    61%{
      transform: translate(-25%,-25%);
      opacity: 0.6;
    }
    75%{
      transform: translate(-50%,-50%);
      opacity: 0.0;
    }
    100%{
      opacity: 0;
    }
  }
  @keyframes showBigBox {
    15%{
      transform: scale(1);
    }
    35%{
      transform:rotate(00deg);
    }
    45%{
      transform: rotate(30deg);
    }
    60%{
      transform: rotate(0deg) scale(1);
    }
    85%{
      transform: scale(1);
    }
    100%{
      transform: scale(0);
    }
  }
</style>
